export default function BreathingCircle({ size = 240, label = 'Breathe' }) {
    return (
        <div className="relative grid place-items-center" style={{ width: size, height: size }} aria-hidden>
            <div className="absolute inset-0 rounded-full breathing-circle animate-breathe-slow" />
            <div className="absolute rounded-full bg-white/30 backdrop-blur-md animate-breathe"
                 style={{ width: size * 0.7, height: size * 0.7 }} />
            <div className="absolute rounded-full bg-cream/70" style={{ width: size * 0.42, height: size * 0.42 }} />
            <span className="relative font-serif text-forest text-lg tracking-wide">{label}</span>
        </div>
    );
}
